import { Inject, Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import {AttributeLocaleFields, Locale, LocaleMappings} from '../models/locale.model';
import {ApiUrl} from '@emm/core/util/api-url.token';
import {standardRetry} from '@emm/core/util/rx.util';

@Injectable({ providedIn: 'root' })
export class LocalesService {

    constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) {}

    getLocaleOptions(): Observable<Locale[]> {
        return this.http
            .get(`${this.apiUrl}/locale-options`)
            .pipe(
                catchError(error => {
                    console.error(error);
                    return null;
                }),
                standardRetry()
            );
    }

    getLocaleMappings(): Observable<LocaleMappings> {
        return this.http
            .get(`${this.apiUrl}/locale-mappings`)
            .pipe(
                catchError(error => {
                    console.error(error);
                    return null;
                }),
                standardRetry()
            );
    }

    getAttributeLocaleFields(itemTag: string, attributeTag: string): Observable<AttributeLocaleFields> {
        return this.http
            .get(`${this.apiUrl}/items/${itemTag}/attributes/${attributeTag}`)
            .pipe(standardRetry());
    }

    saveAttributeLocaleFields(itemTag: string, updatedFields: any[]): Observable<null> {
        return this.http
            .post(
                `${this.apiUrl}/items/${itemTag}/attributes`,
                JSON.stringify(updatedFields),
                {
                    headers: new HttpHeaders({
                        'Content-Type': 'application/json'
                    })
                }
            )
            .pipe(standardRetry());
    }

}
